import pick from 'lodash-es/pick';

enum IDVerificationStatus {
  NO_VERIFICATION_NEEDED = 'NO_VERIFICATION_NEEDED',
  VERIFICATION_NEEDED = 'VERIFICATION_NEEDED',
  VERIFICATION_PROCESSING = 'VERIFICATION_PROCESSING',
  VERIFICATION_SUCCEEDED = 'VERIFICATION_SUCCEEDED',
  VERIFICATION_FAILED_ALLOW_RETRY = 'VERIFICATION_FAILED_ALLOW_RETRY',
  VERIFICATION_FAILED_NO_RETRY = 'VERIFICATION_FAILED_NO_RETRY',
}

type JSONIDVerification = {
  state: IDVerificationStatus;
  errors: {
    code: Maybe<string>;
    reason: Maybe<string>;
  };
};

type IDVerification = {
  state: IDVerificationStatus;
  errors: string[];
};

function fromJSON(idVerification: JSONIDVerification): IDVerification {
  return {
    state: idVerification.state,
    errors: Object.values(pick(idVerification.errors, ['code'])).filter((v) => v) as string[],
  };
}

export { fromJSON, IDVerification, IDVerificationStatus, JSONIDVerification };
